<template>
  <section>
    <div class="box">
      <div class="box-title">
        <h3>Perfect Pay</h3>
      </div>
      <div class="box-content">
        <p>
          Para começar a útilizar precisamos que você informe a Token de Acesso (Integração Vendas) da PrefectPay para que seja possivel puxar as vendas.
        </p>
        <form>
          <div class="flex margin-top-l">
            <div class="flex-1">
              <label>Token de Acesso (Integração Vendas)</label>
              <input class="input" type="text" v-model="storeApiKey" />
            </div>
          </div>
          <div class="flex margin-top-l column">
            <div class="flex-1">
              <label
                >Taxa de Checkout + Gateway (Adicionar o valor em
                percentual)</label
              >
            </div>
            <div class="flex-1">
              <input
                class="input"
                style="width: 90px; min-width:90px"
                :max="100"
                :min="0"
                type="number"
                v-model="taxGatewayCheckout"
              />
              %
            </div>
            <div class="flex-1 margin-top-l">
              <p>*Atenção: Fretes da Perfect Pay serão contados como lucro.</p>
            </div>
          </div>
          <div class="flex margin-top-l">
            <div class="">
              <div class="button primary" @click="savePerfectPay()">
                Salvar
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

  </section>
</template>

<script>
import { mapState } from "vuex";

import {
  saveIntegration,
  getIntegrations,
  deleteIntegration,
} from "@/services/integration";

export default {
  name: "perfect-pay",
  data() {
    return {
      storeLink: "",
      storeApiKey: "",
      taxGatewayCheckout: "",
      defaultTaxGatewayCheckout: 6.9,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
  },
  mounted() {
    this.getIntegrations();
  },
  methods: {
    savePerfectPay() {
      let data = {
        storeApiKey: this.storeApiKey,
      };

      if (!data.storeApiKey) {
        this.$toast.error({
          title: "Erro",
          message: "Você precisa preencher os campos para salvar a integração!",
        });
      }

      let params = {
        perfectpay: {
          api_key: this.storeApiKey,
          tax_gateway_checkout: this.taxGatewayCheckout || this.defaultTaxGatewayCheckout,
        },
      };

      saveIntegration(params)
        .then(() => {
          this.$toast.success({
            title: "Sucesso",
            message: "Integração salva com sucesso",
          });
        })
        .catch(() => {
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um problema ao tentar salvar integração",
          });
        });
    },
    getIntegrations() {
      getIntegrations()
        .then((result) => {
          this.storeApiKey = result.perfectpay.api_key;
          this.taxGatewayCheckout = result.perfectpay.tax_gateway_checkout || this.defaultTaxGatewayCheckout;
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Falhou ao buscar integrações",
          });
        });
    },
    deleteIntegration() {
      deleteIntegration()
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>
